export default "__VITE_ASSET__282a3850__"